import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import SimpleLayout from 'src/layouts/simple';
import CompactLayout from 'src/layouts/compact';
import DashboardLayout from 'src/layouts/dashboard';

// ----------------------------------------------------------------------

const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));
const LandingPage = lazy(() => import('src/pages/landing'));
const ScreenShareViewerPage = lazy(() => import('src/pages/screenshare/view'));
const EnrollmentStartPage = lazy(() => import('src/pages/enrollment/start'));
const EnrollmentFormPage = lazy(() => import('src/pages/enrollment/form'));
const HomeEdRegistrationFormPage = lazy(() => import('src/pages/home-ed-registration/form'));
const BusingEligibilityPage = lazy(() => import('src/pages/busing-eligibility'));
const EmployerEvalPage = lazy(() => import('src/pages/off-campus/employer-eval'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  // Screenshare viewer — no layout wrapper, full viewport
  { path: 'screenshare/view/:roomID', element: <ScreenShareViewerPage /> },
  { path: 'screenshare/view', element: <ScreenShareViewerPage /> },
  // Public employer evaluation — no auth required
  { path: 'employer-eval/:token', element: <EmployerEvalPage /> },
  {
    element: (
      <SimpleLayout>
        <Outlet />
      </SimpleLayout>
    ),
    children: [
      {
        path: 'enroll',
        children: [
          { index: true, element: <EnrollmentStartPage /> },
          { path: 'form', element: <EnrollmentFormPage /> },
          { path: 'home-ed', element: <HomeEdRegistrationFormPage /> },
        ],
      },
      { path: 'landing', element: <LandingPage /> },
      { path: 'busing-eligibility', element: <BusingEligibilityPage /> },
    ],
  },
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
  {
    element: (
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    ),
  },
];
